import { useEffect, useState } from "react";

export function useSectorHover() {
  const [hovered, setHovered] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const getImageWidth = (index: number) => {
    // On mobile, use different heights based on hover state
    if (isMobile) {
      if (hovered === null) return "w-full h-[150px]";
      if (hovered === index) return "w-full h-[400px]";
      return "w-full h-[200px]";
    }

    // Desktop logic
    if (hovered === null) return "flex-[29]";
    if (hovered === index) return "flex-[46]";
    return "flex-[24]";
  };

  const isHovered = (index: number) => hovered === index;

  return {
    hovered,
    setHovered,
    getImageWidth,
    isHovered,
    isMobile,
  };
}
